module.exports = __webpack_public_path__ + "static/media/chemistry_icon.a9ef0aee.png";